export class UserFacingError extends Error {
	title: string;
	description: string;

  /**
   * Creates an error intended for display in the UI.
   * @param {object} options - The error details.
   * @param {string} options.title - The title to be shown in the UI (e.g., in a toast).
   * @param {string} options.description - The detailed description for the user.
   * @param {string} [options.logMessage] - An optional, more technical message for developer logs.
   */
  constructor({
    title,
    description,
    logMessage,
  }: {
    title: string;
    description: string;
    logMessage?: string;
  }) {
    const messageForLogging = logMessage || `${title}: ${description}`;
    super(messageForLogging);

    // --- Custom properties for the UI ---
    this.title = title;
    this.description = description;

    // Standard practice to identify the custom error type
    this.name = "UserFacingError";
  }
}
